import axios from 'axios'
import serverURL from './serverURL'
import getDeviceId from './deviceId'

const api = axios.create({
    baseURL: serverURL,
})

// Setado aqui (na avaliação do módulo, antes de qualquer render do React) e não
// num useEffect do useAuth: efeitos de componentes filhos disparam antes do
// efeito do UserProvider (que envolve o app inteiro), então a primeira
// requisição de qualquer página após um F5/aba nova saía sem X-Device-Id —
// verifyToken.js rejeitava com "Sessão inválida para este dispositivo" mesmo
// sendo o mesmo navegador, derrubando a sessão logo de cara.
const storedToken = localStorage.getItem('token')
if (storedToken) {
    api.defaults.headers.Authorization = `Bearer ${JSON.parse(storedToken)}`
}
api.defaults.headers['X-Device-Id'] = getDeviceId()

// Sessão deslizante: toda resposta autenticada vem com um token renovado
// (+3h) no header x-renewed-token (ver verifyToken.js no backend) — troca o
// token guardado silenciosamente, sem esperar um 401 pra agir.
//
// Sessão expirada ou token inválido: desloga e manda pro login em vez de
// deixar a tela travada esperando uma resposta que nunca vai vir certa.
api.interceptors.response.use(
    (response) => {
        const renewed = response.headers?.['x-renewed-token']
        if (renewed) {
            localStorage.setItem('token', JSON.stringify(renewed))
            api.defaults.headers.Authorization = `Bearer ${renewed}`
        }
        return response
    },
    (error) => {
        if (error.response?.status === 401 && window.location.pathname !== '/login') {
            localStorage.removeItem('token')
            localStorage.removeItem('userName')

            // sessionStorage porque o redirecionamento a seguir recarrega a
            // página inteira — um bus.emit direto não sobreviveria até lá.
            sessionStorage.setItem('pendingFlash', JSON.stringify({
                message: error.response.data?.message || 'Sessão expirada. Faça login novamente.',
                type: 'error',
            }))

            window.location.href = '/login'
        }
        return Promise.reject(error)
    }
)

export default api
